module.exports = __webpack_public_path__ + "img/google-hangout.ab6406bd.png";